export const DIALOGUE_SPEAKER_FACE_MAP: Record<string, string> = {
  T: 't_front_idle_01',
  慧慧: 'huihui_front_idle_01',
  阿博: 'abo_front_idle_01',
  葱葱: 'congcong_front_idle_01',
  sun: 'sun_front_idle_01',
  xiaoai: 'xiaoai_front_idle_01',
  镇长: 'npc_mayor',
  木桶精灵: 'npc_barrel_spirit',
  菠萝大叔: 'npc_uncle_boluo',
  船夫: 'npc_sailor',
  白虎: 'npc_white_tiger',
  凤凰: 'npc_phoenix',
  水瑶: 'npc_shuiyao',
  风赤: 'npc_fengchi',
  熙苑: 'npc_xiyuan',
  祀神: 'npc_priestess_sun',
  麒麟: 'npc_qilin',
  无相: 'mon_wuxiang_01',
  风之防御人: 'mon_feng_defender_01',
  预言: 'npc_priestess_sun',
  UNKNOWN: 'mon_wuxiang_01',
  神秘声音: 'mon_wuxiang_01',
}
